import './dairy.scss';

export default () => {

};

